import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Badge, Card } from "react-bootstrap";

import BoxLoading from "../general/BoxLoading";

import {
  getProductDetail,
  changeLike,
} from "../../redux/features/plan/actions";
//
import { showPlanModal, choosePlan } from "../../redux/features/plan/slice";

function ProductItem({
  mine = false,
  item,
  index,
  changeLikeInfo,
  choosePlan,
  showPlanModal,
}) {
  const [loading, setLoading] = useState(false);

  /**
   * Get Choosed Product Detail
   * Set Choosed In Store
   * Open Modal
   */
  const getScriptDetail = async () => {
    choosePlan(item);
    showPlanModal({ show: true, step: "choose-plan", type: "product" });
    // // start loading
    // setLoading(true);

    // // request
    // await getProductDetail(item.id).then((res) => {
    //   if (res) {
    //     choosePlan(res);
    //     showPlanModal({ show: true, step: "choose-plan", type: "product" });
    //   }
    // });

    // // stop loading
    // setLoading(false);
  };

  const change_like = () => {
    changeLike(item.id).then((res) => {
      if (res) {
        changeLikeInfo(index);
      }
    });
  };

  return (
    <Card className="pine-item">
      <Card.Body>
        <div className="img-holder pointer" onClick={getScriptDetail}>
          <img src={item.image} alt={item.title} />
        </div>

        <h5 className="mb-2 pointer" onClick={getScriptDetail}>
          {item.title}
        </h5>
        <p className="subject mb-4">{item.short_description}</p>

        <div>
          <small className="smaller">
            Price{" "}
            {!mine && item.bought && (
              <span className="text-warning">(Buyed before)</span>
            )}
          </small>
          <div className="d-flex align-items-baseline">
            <small className="fw-bolder text-black">${item.price_usd}</small>
            {!!item.price_point && (
              <small className="text-warning smaller fw-bolder ms-1">
                or 200 Points
              </small>
            )}
          </div>
        </div>

        <div className="more-info mt-3 w-100 gap-2">
          <Badge
            onClick={change_like}
            bg={item.myLike ? "warning" : "light"}
            className="d-flex align-items-center justify-content-center w-100 pointer"
          >
            <i
              className={`lar la-thumbs-up text-${
                item.myLike ? "white" : "black"
              }`}
            ></i>
            <small className={`text-${item.myLike ? "white" : "black"} ms-1`}>
              {item.totalLikes}
            </small>
          </Badge>

          <Badge
            bg="light"
            className="d-flex align-items-center justify-content-center w-100"
          >
            <i className="lar la-comment-dots text-black"></i>
            <small className="text-black ms-1">7</small>
          </Badge>

          <Badge
            bg="light"
            className="d-flex align-items-center justify-content-center w-100"
          >
            <i className="lar la-star text-black"></i>
            <small className="text-black ms-1">{item.vote.toFixed(1)}</small>
          </Badge>
        </div>
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

const mapDispatchToProps = {
  showPlanModal,
  choosePlan,
};

ProductItem.propTypes = {
  item: PropTypes.object.isRequired,
  showPlanModal: PropTypes.func.isRequired,
  choosePlan: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ProductItem);
